<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (form && asset) {
  @if (tradeFacade.isCombinedOrderVerified$ | async) {
    <ng-container *ngTemplateOutlet="combinedOrder" />
    <ng-container *ngTemplateOutlet="sum" />
  } @else {
    <ng-container *ngTemplateOutlet="classicOrder" />
  }
}

<ng-template #orderHeader>
  <div class="mb-3 font-bold">
    {{ 'trade.confirm.data.header' | transloco }}
  </div>
</ng-template>

<ng-template #classicOrder>
  <ng-container *ngTemplateOutlet="orderHeader" />
  <div class="row mb-3">
    <div class="col-12 col-md-6 pr-md-3">
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.direction' | transloco }}</div>
        <div class="font-bold">
          {{ form.get('direction').value | displayLabel }}
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.marketPlace' | transloco }}</div>
        <div class="font-bold">{{ asset.marketName }}</div>
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <div>
          {{ 'trade.confirm.data.validity' | transloco }}
        </div>
        <div class="font-bold">
          @if (!(isBuy && execType === 'market')) {
            {{ form.get('quantityForm').get('validToDate').value | date: 'shortDate' }}
          }
          @if (isBuy && execType === 'market') {
            {{ 'trade.confirm.data.buy-market-validity' | transloco }}
          }
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.exec-type' | transloco }}</div>
        <div class="font-bold">
          {{ execType | displayLabel }}
        </div>
      </div>
      <hr />
      @if (form.get('execType').value === 'stop') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.stop-price' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('optionsForm')?.get('stopPrice').value | currency: 'EUR' : 'symbol' : quoteFormat }}
          </div>
        </div>
        <hr />
      }
      @if (form.get('execType').value === 'oco') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.stop-loss' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('optionsForm')?.get('stopLoss').value | currency: 'EUR' : 'symbol' : quoteFormat }}
          </div>
        </div>
        <hr />
      }
      @if (form.get('execType').value === 'tsl') {
        <div class="d-flex justify-content-between">
          @if (!form.get('optionsForm').get('initialStopPrice').value) {
            <div>{{ 'trade.confirm.data.stop-price' | transloco }}</div>
            <div class="font-bold">
              {{ tradeService.tickingStopPrice$ | async | currency: 'EUR' : 'symbol' : quoteFormat }}
            </div>
          } @else {
            <div>{{ 'trade.confirm.data.initial-stop-price' | transloco }}</div>
            <div class="font-bold">
              {{ form.get('optionsForm').get('initialStopPrice').value | currency: 'EUR' : 'symbol' : quoteFormat }}
            </div>
          }
        </div>
        <hr class="strong" />
      }
    </div>
    <div class="col-12 col-md-6 pl-md-3">
      @if (form.get('execType').value === 'tsl') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.trailing' | transloco }}</div>
          <div class="font-bold">
            @if (form.get('optionsForm')?.get('trailingType').value === 'abs') {
              {{ form.get('optionsForm')?.get('trailingAbs').value | currency: 'EUR' : 'symbol' : quoteFormat }}
            } @else {
              {{ form.get('optionsForm')?.get('trailingRel').value | number }} %
            }
          </div>
        </div>
        <hr />
      }
      @if (form.get('execType').value === 'limit') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.limit-price' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('optionsForm')?.get('limitPrice').value | currency: 'EUR' : 'symbol' : quoteFormat }}
          </div>
        </div>
        <hr />
      }
      @if (execType === 'stoplimit') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.limit-price' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('optionsForm')?.get('stopLimitPrice').value | currency: 'EUR' : 'symbol' : quoteFormat }}
          </div>
        </div>
        <hr />
      }
      @if (execType === 'oco') {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.take-profit' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('optionsForm')?.get('takeProfit').value | currency: 'EUR' : 'symbol' : quoteFormat }}
          </div>
        </div>
        <hr />
      }
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.quote' | transloco }}</div>
        @if (quote) {
          <div class="font-bold">
            <span class="quoteindicator-variant4" [zeroBlink]="isBuy" [val]="quote.ask">{{
              quote.ask | priceScale: asset?.priceScale
            }}</span>
            <span [class.ml-2]="isBuy"> / </span>
            <span class="quoteindicator-variant4" [zeroBlink]="isSell" [val]="quote.bid">{{
              quote.bid | priceScale: asset?.priceScale
            }}</span>
          </div>
        }
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.quantity' | transloco }}</div>
        <div class="font-bold">
          {{ form.get('quantityForm').get('quantity').value | number: quantityFormat }}
        </div>
      </div>
      <hr />
      <div class="d-flex justify-content-between">
        <div>{{ 'trade.confirm.data.minimum-quantity-surcharge' | transloco }}</div>
        <div class="font-bold">
          @if (minimumQuantitySurcharge?.value) {
            {{ minimumQuantitySurcharge?.value | currency }}
          } @else {
            &mdash;
          }
        </div>
      </div>
      <hr />
      @if (provision) {
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.provision' | transloco }}</div>
          <div class="font-bold">{{ provision | currency }}</div>
        </div>
        <hr />
      }
      @if (provision) {
        <div class="d-flex justify-content-between">
          <div>
            <span [innerHTML]="'trade.confirm.data.discount' | transloco"></span>
            <web-design-system-icon
              name="info"
              size="small"
              class="cursor-pointer ml-1"
              [ngbTooltip]="'trade.confirm.data.tooltip.discount' | transloco"
              tooltipClass="without-arrow"
              triggers="hover"
              placement="bottom"
            />
          </div>
          <div class="font-bold zero-text course-green">{{ provision | currency }}</div>
        </div>
        <hr />
      }
      <div class="d-flex justify-content-between">
        <div class="font-bold">
          {{ (isEstimatedOrderValue ? 'trade.confirm.data.estimated-order-value' : 'trade.confirm.data.order-value') | transloco }}
        </div>
        <div class="font-bold">
          {{ orderValue | currency }}
        </div>
      </div>
      <hr class="strong" />
    </div>
  </div>
</ng-template>

<ng-template #combinedOrder>
  <ng-container *ngTemplateOutlet="orderHeader" />
  @if (tradeFacade.isFractionalOrderOnly$ | async) {
    <ng-container *ngTemplateOutlet="fractionalOrder" />
  } @else {
    @if (tradeFacade.combinedMarketOrder$ | async; as marketOrder) {
      <div class="row mb-3">
        <div class="col-12 col-md-6 pr-md-3">
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.direction' | transloco }}</div>
            <div class="font-bold">
              {{ marketOrder.direction | displayLabel }}
            </div>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.marketPlace' | transloco }}</div>
            <div class="font-bold">{{ asset.marketName }}</div>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div>
              {{ 'trade.confirm.data.validity' | transloco }}
            </div>
            <div class="font-bold">
              @if (!isBuy) {
                {{ marketOrder.validToDate | date: 'shortDate' }}
              }
              @if (isBuy) {
                {{ 'trade.confirm.data.buy-market-validity' | transloco }}
              }
            </div>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.exec-type' | transloco }}</div>
            <div class="font-bold">
              {{ execType | displayLabel }}
            </div>
          </div>
          <hr />
        </div>
        <div class="col-12 col-md-6 pl-md-3">
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.quote' | transloco }}</div>
            @if (quote) {
              <div class="font-bold">
                <span class="quoteindicator-variant4" [zeroBlink]="isBuy" [val]="quote.ask">{{
                  quote.ask | priceScale: asset?.priceScale
                }}</span>
                <span [class.ml-2]="isBuy"> / </span>
                <span class="quoteindicator-variant4" [zeroBlink]="isSell" [val]="quote.bid">{{
                  quote.bid | priceScale: asset?.priceScale
                }}</span>
              </div>
            }
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.quantity' | transloco }}</div>
            <div class="font-bold">
              {{ marketOrder.quantity | number: quantityFormat }}
            </div>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div>{{ 'trade.confirm.data.minimum-quantity-surcharge' | transloco }}</div>
            <div class="font-bold">
              @if (marketOrder.minimumQuantitySurcharge) {
                {{ marketOrder.minimumQuantitySurcharge | currency }}
              } @else {
                &mdash;
              }
            </div>
          </div>
          <hr />
          <div class="d-flex justify-content-between">
            <div class="font-bold">
              {{ (isEstimatedOrderValue ? 'trade.confirm.data.estimated-order-value' : 'trade.confirm.data.order-value') | transloco }}
            </div>
            <div class="font-bold">
              {{ marketOrder | combinedMarketOrderValue: quote | currency }}
            </div>
          </div>
          <hr class="strong" />
        </div>
      </div>
    }

    @if (tradeFacade.combinedFractionalOrder$ | async) {
      <hr class="bold mb-3" />
      <ng-container *ngTemplateOutlet="fractionalOrder" />
    }
  }
</ng-template>

<ng-template #fractionalOrder>
  @if (tradeFacade.combinedFractionalOrder$ | async; as fractionalOrder) {
    <div class="row mb-3">
      <div class="col-12 col-md-6 pr-md-3">
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.direction' | transloco }}</div>
          <div class="font-bold">
            {{ form.get('direction').value | displayLabel }}
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.marketPlace' | transloco }}</div>
          <div class="font-bold">{{ asset.marketName }}</div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div>
            {{ 'trade.confirm.data.validity' | transloco }}
          </div>
          <div class="font-bold">
            {{ fractionalOrder.validToDate | date: 'shortDate' }} {{ 'trade.confirm.data.fractional-time' | transloco }}
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.exec-type' | transloco }}</div>
          <div class="font-bold d-flex align-items-center">
            <div>
              {{ 'trade.confirm.data.exec-type-fraction' | transloco }}
            </div>
            @if ((tradeFacade.isFractionalOrderOnly$ | async) === false) {
              <div class="icon icon-16 cursor-pointer zero-icon red ml-2" (click)="removeFractionalOrder()">
                <svg>
                  <use xlink:href="/assets/img/svgs/svgset.svg#trashcan" />
                </svg>
              </div>
            }
          </div>
        </div>
        <hr />
      </div>
      <div class="col-12 col-md-6 pl-md-3">
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.quote' | transloco }}</div>
          @if (quote) {
            <div class="font-bold">
              <span class="quoteindicator-variant4" [zeroBlink]="isBuy" [val]="quote.ask">{{
                quote.ask | priceScale: asset?.priceScale
              }}</span>
              <span [class.ml-2]="isBuy"> / </span>
              <span class="quoteindicator-variant4" [zeroBlink]="isSell" [val]="quote.bid">{{
                quote.bid | priceScale: asset?.priceScale
              }}</span>
            </div>
          }
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div>
            {{ 'trade.confirm.data.quantity' | transloco }}
            @if (form.get('direction').value === 'buy') {
              <web-design-system-icon
                class="cursor-pointer"
                name="info"
                size="small"
                [ngbTooltip]="quantityTooltip"
                tooltipClass="without-arrow"
                triggers="hover"
                placement="bottom"
              />
            }
          </div>
          <div class="font-bold">
            {{ fractionalOrder | dynamicQuantity: quote | number: quantityFormat }}
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div>{{ 'trade.confirm.data.fractional-surcharge' | transloco }}</div>
          <div class="font-bold">
            @if (fractionalOrder.fractionalSurcharge) {
              {{ fractionalOrder.fractionalSurcharge | currency }}
            } @else {
              &mdash;
            }
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-between">
          <div class="font-bold">
            {{ 'trade.confirm.data.fixed-remaining-amount' | transloco }}
            @if (form.get('direction').value === 'buy') {
              <web-design-system-icon
                class="cursor-pointer"
                name="info"
                size="small"
                [ngbTooltip]="fixedRemainingAmountTooltip"
                tooltipClass="without-arrow"
                triggers="hover"
                placement="bottom"
              />
            }
          </div>
          <div class="font-bold">
            {{ fractionalOrder | combinedFractionalOrderValue: quote | currency }}
          </div>
        </div>
        <hr class="strong" />
      </div>
    </div>
  }
</ng-template>

<ng-template #sum>
  @if (tradeFacade.combinedFractionalOrder$ | async; as fractionalOrder) {
    @if (tradeFacade.combinedMarketOrder$ | async; as marketOrder) {
      @if (fractionalOrder.quantity > 0 && marketOrder.quantity >= 1) {
        <hr class="bolder mb-3" />
        <div class="row mb-3">
          <div class="col-12 col-md-8 zero-text p-bigger-bold">{{ 'trade.confirm.data.sum' | transloco }}</div>
          <div class="col-12 col-md-4 text-right zero-text p-huge-med">
            {{ marketOrder | combinedOrderSum: fractionalOrder : quote | currency }}
          </div>
        </div>
      }
    }
  }
</ng-template>

<ng-template #fixedRemainingAmountTooltip>
  @if (tradeFacade.isFractionalOrderOnly$ | async) {
    <ng-container *ngTemplateOutlet="simpleTooltip; context: { type: 'fixed-remaining-amount-fractional' }" />
  } @else {
    <ng-container *ngTemplateOutlet="simpleTooltip; context: { type: 'fixed-remaining-amount' }" />
  }
</ng-template>

<ng-template #quantityTooltip>
  <ng-container *ngTemplateOutlet="simpleTooltip; context: { type: 'quantity' }" />
</ng-template>

<ng-template #simpleTooltip let-type="type">
  <div class="text-left zero-text p-base-reg" [innerHTML]="'trade.confirm.data.tooltip.' + type | transloco"></div>
</ng-template>
